import { useMutation, useQueryClient } from '@tanstack/react-query';
import { expertTipApi } from '../services/adminApi';
import { queryKeys } from '../utils/queryKeys';
import type { ExpertTipFormData } from '../types/expert-tip';

export function useUpdateExpertTip(id: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (formData: ExpertTipFormData) =>
      expertTipApi.updateExpertTip(id, formData),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.expertTips.detail(id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.expertTips.lists() });
    },
  });
}
